import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../bread';
import logoimg from '../../assets/images/logo.png';
import transp from '../../assets/images/transp.png';
import '../../styles/header.scss';
import { slide as Menu } from 'react-burger-menu'

function Header() {
    const [breadOn, setBreadOn] = useState();
    const [pathName, setPathName] = useState(window.location.pathname)
    const [breadcrumbItems, setBreadcrumItems] = useState()


    const iniciaBread = async () => {
        if (pathName == "/transparencia") {
            setBreadOn(false)
        } else {
            setBreadOn(true)
            await setaBread(pathName);
        }
    }

    const setaBread = async (path) => {
        switch (path) {
            case "/transparencia/diario":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Diário Oficial Eletrônico', active: true }
                ]);
                break;
            case "/transparencia/diario/expomacuco/2025":
                setBreadcrumItems([
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Leis e decretos relacionados à Expo Macuco 2025', active: true }
                ]);
                break;
            case "/transparencia/diario/expomacuco/2024":
                setBreadcrumItems([
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Leis e decretos relacionados à Expo Macuco 2024', active: true }
                ]);
                break;
            case "/transparencia/diario/expomacuco/2023":
                setBreadcrumItems([
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Leis e decretos relacionados à Expo Macuco 2023', active: true }
                ]);
                break;
            case "/transparencia/diario/expomacuco/anteriores":
                setBreadcrumItems([
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Leis e decretos relacionados à Expo Macuco em anos anteriores a 2023', active: true }
                ]);
                break;
            case "/transparencia/mapa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Mapa do site', active: true }
                ]);
                break;
            case "/transparencia/lgpd":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei Geral de Proteção de Dados (LGPD)', active: true }
                ]);
                break;
            case "/transparencia/lgpd/formulario":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei Geral de Proteção de Dados (LGPD)' },
                    { label: 'Formulário de Solicitação de acesso aos Dados', active: true }
                ]);
                break;
            case "/transparencia/ti":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Tecnologia da Informação e Comunicação', active: true }
                ]);
                break;
            case "/transparencia/atricon":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lista de tópicos da ATRICON', active: true }
                ]);
                break;
            case "/transparencia/emendasrj":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Emendas Parlamentares Estaduais', active: true }
                ]);
                break;
            case "/transparencia/servicos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Serviços Online da Prefeitura Municipal de Macuco', active: true }
                ]);
                break;
            case "/transparencia/pesquisa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Pesquisa de satisfação com serviços públicos', active: true }
                ]);
                break;
            case "/transparencia/pesquisa/resultados":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'E-SIC', link: '/transparencia/ouvidoria' },
                    { label: 'Resultado das pesquisas de satisfação com serviços públicos realizadas', active: true }
                ]);
                break;
            case "/transparencia/lrf":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei de Responsabilidade Fiscal', active: true }
                ]);
                break;
            case "/transparencia/lrf/rreo":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei de Responsabilidade Fiscal', link: '/transparencia/lrf' },
                    { label: 'Relatório Resumido da Execução Orçamentária', active: true }
                ]);
                break;
            case "/transparencia/lrf/rgf":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei de Responsabilidade Fiscal', link: '/transparencia/lrf' },
                    { label: 'Relatório de Gestão Fiscal', active: true }
                ]);
                break;
            case "/transparencia/lrf/dcrgf":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Lei de Responsabilidade Fiscal', link: '/transparencia/lrf' },
                    { label: 'Demonstrativo Consolidado do Relatório de Gestão Fiscal', active: true }
                ]);
                break;
            case "/transparencia/leis/orcamento":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Legislação Orçamentária Municipal', active: true }
                ]);
                break;
            case "/transparencia/leis/loa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Legislação Orçamentária Municipal', link: '/transparencia/leis/orcamento' },
                    { label: 'Lei Orçamentária Anual', active: true }
                ]);
                break;
            case "/transparencia/leis/ldo":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Legislação Orçamentária Municipal', link: '/transparencia/leis/orcamento' },
                    { label: 'Lei de Diretrizes Orçamentárias', active: true }
                ]);
                break;
            case "/transparencia/leis/ppa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Legislação Orçamentária Municipal', link: '/transparencia/leis/orcamento' },
                    { label: 'Lei Orçamentária Plurianual', active: true }
                ]);
                break;
            case "/transparencia/renuncias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Renúncias de Receita', active: true }
                ]);
                break;
            case "/transparencia/contas/renuncias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Renúncias de Receita', link: '/transparencia/renuncias' },
                    { label: 'Renúncias de Receita por ano', active: true }
                ]);
                break;
            case "/transparencia/renunciareceita":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Renúncias de Receita', link: '/transparencia/renuncias' },
                    { label: 'Renúncias de Receita detalhadas', active: true }
                ]);
                break;
            case "/transparencia/projetocultural":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Renúncias de Receita', link: '/transparencia/renuncias' },
                    { label: 'Projetos Culturais/Esportivos resultados de Renúncias de Receita', active: true }
                ]);
                break;
            case "/transparencia/licitacao":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', active: true }
                ]);
                break;
            case "/transparencia/licitacao/aviso":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Aviso de Editais de Licitação', active: true }
                ]);
                break;
            case "/transparencia/licitacao/todas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Todas Licitações', active: true }
                ]);
                break;
            case "/transparencia/licitacao/andamento":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Licitações em Andamento', active: true }
                ]);
                break;
            case "/transparencia/licitacao/encerradas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Licitações Encerradas', active: true }
                ]);
                break;
            case "/transparencia/licitacao/covid":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Licitações Feitas Durante a Pandemia de COVID-19', active: true }
                ]);
                break;
            case "/transparencia/licitacao/dispensa-covid":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Licitações', link: '/transparencia/licitacao' },
                    { label: 'Dispensas Emergenciais Realizadas Durante a Pandemia de COVID-19', active: true }
                ]);
                break;
            case "/transparencia/licitacao/expomacuco/2025":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Licitações e dispensas realizadas para Exposição Agropecuária de Macuco em 2025', active: true }
                ]);
                break;
            case "/transparencia/licitacao/expomacuco/2024":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Licitações e dispensas realizadas para Exposição Agropecuária de Macuco em 2024', active: true }
                ]);
                break;
            case "/transparencia/licitacao/expomacuco/2023":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Licitações e dispensas realizadas para Exposição Agropecuária de Macuco em 2023', active: true }
                ]);
                break;
            case "/transparencia/licitacao/expomacuco/anteriores":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Licitações e dispensas realizadas para Exposição Agropecuária de Macuco em anos anteriores a 2023', active: true }
                ]);
                break;
            case "/transparencia/contratos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', active: true }
                ]);
                break;
            case "/transparencia/contratos/listar":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Contratos Firmados', active: true }
                ]);
                break;
            case "/transparencia/contratos/expomacuco/2025":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Contratos Firmados na Exposição Agropecuária de Macuco em 2025', active: true }
                ]);
                break;
            case "/transparencia/contratos/expomacuco/2024":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Contratos Firmados na Exposição Agropecuária de Macuco em 2024', active: true }
                ]);
                break;
            case "/transparencia/contratos/expomacuco/2023":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Contratos Firmados na Exposição Agropecuária de Macuco em 2023', active: true }
                ]);
                break;
            case "/transparencia/contratos/expomacuco/anteriores":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Contratos Firmados na Exposição Agropecuária de Macuco em anos anteriores a 2023', active: true }
                ]);
                break;
            case "/transparencia/contratos/covid":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Contratos Firmados Durante a Pandemia de COVID-19', active: true }
                ]);
                break;
            case "/transparencia/expomacuco":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2025":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2025', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2025/publicacoes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2025', link: '/transparencia/expomacuco/2025' },
                    { label: 'Publicações relacionadas à Expo Macuco 2025', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2024":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2024', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2024/publicacoes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2024', link: '/transparencia/expomacuco/2024' },
                    { label: 'Publicações relacionadas à Expo Macuco 2024', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2023":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2023', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/2023/publicacoes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco 2023', link: '/transparencia/expomacuco/2023' },
                    { label: 'Publicações relacionadas à Expo Macuco 2023', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/anteriores":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco de anos anteriores a 2023', active: true }
                ]);
                break;
            case "/transparencia/expomacuco/anteriores/publicacoes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Expo Macuco', link: '/transparencia/expomacuco' },
                    { label: 'Prestação de Contas da Expo Macuco anteriores a 2023', link: '/transparencia/expomacuco/anteriores' },
                    { label: 'Publicações relacionadas à Expo Macuco anteriores a 2023', active: true }
                ]);
                break;
            case "/transparencia/obras":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Obras', active: true }
                ]);
                break;
            case "/transparencia/obras/todas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Obras', link: '/transparencia/obras' },
                    { label: 'Todas Obras', active: true }
                ]);
                break;
            case "/transparencia/obras/paralizadas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Obras', link: '/transparencia/obras' },
                    { label: 'Obras Paralizadas', active: true }
                ]);
                break;
            case "/transparencia/contratos/fiscais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Servidores Municipais Fiscais de Contratos', active: true }
                ]);
                break;
            case "/transparencia/contratos/chamamentos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Contratos de Chamamentos Públicos da Saúde', active: true }
                ]);
                break;
            case "/transparencia/contratos/contratados":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Lista de Contratados pela Prefeitura', active: true }
                ]);
                break;
            case "/transparencia/contratos/licitantes":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contratos', link: '/transparencia/contratos' },
                    { label: 'Lista de Licitantes cadastrados na Prefeitura', active: true }
                ]);
                break;
            case "/transparencia/leis":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Leis & Decretos Municipais', active: true }
                ]);
                break;
            case "/transparencia/leis/decretos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Leis & Decretos Municipais', link: '/transparencia/leis' },
                    { label: 'Decretos do Poder Executivo', active: true }
                ]);
                break;
            case "/transparencia/leis/covid":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Leis & Decretos Municipais', link: '/transparencia/leis' },
                    { label: 'Leis & Decretos Municipais Durante a Pandemia de COVID-19', active: true }
                ]);
                break;
            case "/transparencia/leis/municipais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Leis & Decretos Municipais', link: '/transparencia/leis' },
                    { label: 'Legislação Municipal', active: true }
                ]);
                break;
            case "/transparencia/leis/transparencia":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Leis & Decretos Municipais', link: '/transparencia/leis' },
                    { label: 'Legislação Municipal da Transparência Pública', active: true }
                ]);
                break;
            case "/transparencia/diarias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Diárias de Viagens', active: true }
                ]);
                break;
            case "/transparencia/diarias/tabela":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Diárias de Viagens', link: '/transparencia/diarias' },
                    { label: 'Tabela de Diárias concedidas aos servidores do Município de Macuco', active: true }
                ]);
                break;
            case "/transparencia/folha":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', active: true }
                ]);
                break;
            case "/transparencia/dividaativa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Dívida Ativa com o Município', active: true }
                ]);
                break;
            case "/transparencia/folha/estagiarios":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Estagiários', active: true }
                ]);
                break;
            case "/transparencia/folha/terceirizados":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Funcionários Terceirizados', active: true }
                ]);
                break;
            case "/transparencia/folha/concursos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Concursos Públicos', active: true }
                ]);
                break;
            case "/transparencia/folha/concursos/2001":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Concursos Públicos', link: '/transparencia/concursos' },
                    { label: '2001', active: true }
                ]);
                break;
            case "/transparencia/folha/concursos/2010":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Concursos Públicos', link: '/transparencia/concursos' },
                    { label: '2010', active: true }
                ]);
                break;
            case "/transparencia/folha/concursos/2012":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Recursos Humanos', link: '/transparencia/folha' },
                    { label: 'Concursos Públicos', link: '/transparencia/concursos' },
                    { label: '2012', active: true }
                ]);
                break;
            case "/transparencia/contas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contas Públicas', active: true }
                ]);
                break;
            case "/transparencia/contas/prestacaocontas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contas Públicas', link: '/transparencia/contas' },
                    { label: 'Prestação de Contas', active: true }
                ]);
                break;
            case "/transparencia/contas/camara":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contas Públicas', link: '/transparencia/contas' },
                    { label: 'Resultado da Apreciação do Poder Legislativo', active: true }
                ]);
                break;
            case "/transparencia/contas/audiencias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contas Públicas', link: '/transparencia/contas' },
                    { label: 'Audiências de Prestação de Contas Públicas', active: true }
                ]);
                break;
            case "/transparencia/contas/audiencias/metasfiscais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Contas Públicas', link: '/transparencia/contas' },
                    { label: 'Audiências de Prestação de Contas Públicas', link: '/transparencia/contas/audiencias' },
                    { label: 'Atas das Audiências Públicas de Apresentação de Metas Fiscais', active: true }
                ]);
                break;
            case "/transparencia/saude":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/atasaudiencia":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Atas das Audiências Públicas de apresentação dos Relatórios das Ações, serviços e Aplicações Financeiras em Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/atasconselho":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Atas de Reuniões do Conselho Municipal de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/profissionais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Profissionais da Rede Municipal de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/parecer":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Pareceres Conclusivos do Conselho Municipal de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/planoanual":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Programações Anuais de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/planomunicipal":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Planos Municipais de Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/relatorioanual":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Relatórios Anuais da Gestão em Saúde', active: true }
                ]);
                break;
            case "/transparencia/saude/remume":
            case "/transparencia/saude/remume/listar":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Relação Municipal de Medicamentos Essenciais', active: true }
                ]);
                break;
            case "/transparencia/saude/covid":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria de Saúde', link: '/transparencia/saude' },
                    { label: 'Transparência da COVID-19', active: true }
                ]);
                break;
            case "/transparencia/balanco":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Balanços Municipais', active: true }
                ]);
                break;
            case "/transparencia/balanco/orcamentario":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Balanços Municipais', link: '/transparencia/balanco' },
                    { label: 'Balanços Orçamentários', active: true }
                ]);
                break;
            case "/transparencia/balanco/financeiro":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Balanços Municipais', link: '/transparencia/balanco' },
                    { label: 'Balanços Financeiros', active: true }
                ]);
                break;
            case "/transparencia/balanco/patrimonial":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Balanços Municipais', link: '/transparencia/balanco' },
                    { label: 'Balanços Patrimoniais', active: true }
                ]);
                break;
            case "/transparencia/transferenciasestado":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Transferências Estaduais de Recurso', active: true }
                ]);
                break;
            case "/transparencia/transferenciasestado/voluntarias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Transferências Estaduais de Recurso', link: '/transparencia/transferenciasestado' },
                    { label: 'Transferências Estaduais Voluntárias de Recurso', active: true }
                ]);
                break;
            case "/transparencia/transferenciasestado/obrigatorias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Transferências Estaduais de Recurso', link: '/transparencia/transferenciasestado' },
                    { label: 'Transferências Estaduais Obrigatórias de Recurso', active: true }
                ]);
                break;
            case "/transparencia/atos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Atos Normativos', active: true }
                ]);
                break;
            case "/transparencia/orgaos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', active: true }
                ]);
                break;
            case "/transparencia/orgaos/carta":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Carta de Serviços ao Cidadão', active: true }
                ]);
                break;
            case "/transparencia/educacao":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', active: true }
                ]);
                break;
            case "/transparencia/educacao/parecer":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Pareceres Conclusivos Conselho Municipal do FUNDEB', active: true }
                ]);
                break;
            case "/transparencia/educacao/atasconselho":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Atas do Conselho Municipal de Educação', active: true }
                ]);
                break;
            case "/transparencia/educacao/planomunicipal":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Planos Municipais de Educação', active: true }
                ]);
                break;
            case "/transparencia/educacao/relatorioanual":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Relatório Anual de Gestão', active: true }
                ]);
                break;
            case "/transparencia/educacao/creche":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Cadastro Único da Creche Municipal', active: true }
                ]);
                break;
            case "/transparencia/educacao/receita":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Arrecadações detalhadas', active: true }
                ]);
                break;
            case "/transparencia/educacao/despesa":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Secretaria Municipal de Educação', link: '/transparencia/educacao' },
                    { label: 'Despesas detalhadas', active: true }
                ]);
                break;
            case "/transparencia/veiculos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Frota Municipal de Veículos', active: true }
                ]);
                break;
            case "/transparencia/orgaos/secretarias":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Secretarias Municipais', active: true }
                ]);
                break;
            case "/transparencia/orgaos/locais/saude":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Pontos de Atendimento da Rede Municipal de Saúde', active: true }
                ]);
                break;
            case "/transparencia/orgaos/locais/educacao":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Escolas e Unidades de Educação da Rede Municipal', active: true }
                ]);
                break;
            case "/transparencia/orgaos/locais/social":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Pontos de Atendimento da Rede Municipal de Assistência Social', active: true }
                ]);
                break;
            case "/transparencia/orgaos/locais/esporte":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Quadras e Centros Esportivos do Município', active: true }
                ]);
                break;
            case "/transparencia/orgaos/locais":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Órgãos Municipais', link: '/transparencia/orgaos' },
                    { label: 'Todos Órgãos Municipais', active: true }
                ]);
                break;
            case "/transparencia/perguntas":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Perguntas Frequentes', active: true }
                ]);
                break;
            case "/transparencia/concessaocedae":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Concessão CEDAE', active: true }
                ]);
                break;
            case "/transparencia/partidospoliticos":
                setBreadcrumItems([
                    { label: 'Início', link: '/transparencia' },
                    { label: 'Notificação Liberação Recursos – Lei 9.452/1997', active: true }
                ]);
                break;
            default:
                setBreadcrumItems([
                    { label: 'Você está na página inicial!', active: true }
                ]);
                break;
        }
    }

    useEffect(() => {
        iniciaBread();
    }, []);


    return (
        <Fragment>
            <header className='header'>
                <Row xs={2} lg={3}>
                    <Col xs={10} lg={3}>
                        <a href="/transparencia" alt="Portal da Transparência do Município de Macuco">
                            <img src={logoimg} className='logo' alt="Portal da Transparência do Município de Macuco" />
                        </a>
                    </Col>
                    <Col xs={10} lg={5}>
                        <a href="/transparencia" alt="Portal da Transparência do Município de Macuco">
                            <img src={transp} className='transp' alt="Portal da Transparência do Município de Macuco" />
                        </a>
                    </Col>
                </Row>
                {breadOn ?
                    <Fragment>
                        <Row>
                            <Col xs={{ span: 10, offset: 1 }}>
                                <Breadcrumb items={breadcrumbItems} />
                            </Col>
                        </Row>
                    </Fragment> : ''
                }
                <Menu right>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br">Site da Prefeitura</a>
                    <a className="menu-item" href="https://sistema.ouvidorias.gov.br/publico/rj/macuco/Manifestacao/RegistrarManifestacao">Ouvidoria</a>
                    <a className="menu-item" href="leis/transparencia">Legislação de Transparência</a>
                    <a className="menu-item" href="orgaos">Órgãos da Prefeitura</a>
                    <a className="menu-item" href="mapa">Mapa do Portal</a>
                </Menu>
            </header>
        </Fragment >

    )
}

export default Header;